import GradeIcon from '@material-ui/icons/Grade';
import Icon from '@material-ui/icons/Person';
import PasswordIcon from '@material-ui/icons/VpnKey';
import moment from 'moment';
import React from 'react';
import { SingleFieldList } from 'react-admin';
import { CreateButton } from '../../../buttons';
import { TemporaryPasswordDialog } from '../../../components';
import { CreateDialog, EditDialog, Filter, NestedResourceList, ResourceList, ResourceShow, SimpleShowLayout, Tab, TabbedShowLayout } from '../../../controllers';
import { AgeField, BooleanField, CurrentVersionField, DateField, DateTimeField, EditableProjectLinkField, EnumField, ImageField, LinkField, NumberField, ReferenceField, ReferenceManyField, SkillProgressField, TextField, TimeZoneField } from '../../../fields';
import { BooleanInput, DateInput, EnumInput, InputGroup, NestedReferenceInput, NumberInput, ReferenceInput, SearchInput, TextInput, TimeZoneSelectInput } from '../../../inputs';
import curriculum_accomplishments from '../../users/curriculum_accomplishments';
import followings from '../../users/followings';
import friend_requests from '../../users/friend_requests';
import memberships from '../../users/memberships';
import mission_achievements from '../../users/mission_achievements';
import projects from './projects';

export default {
  Icon,
  menuItems: [
    {
      name: 'New Accomplishment',
      type: 'component',
      if: user => user.scope === 'child',
      icon: GradeIcon,
      Component: props => (
        <CreateDialog
          {...props}
          fixedValue={{
            user_id: props.parentResource.id,
          }}
          resource="curriculum_accomplishments"
        >
          <ReferenceInput
            filter={{ processor: 'manual' }}
            source="curriculum_activity_id"
            required
          />
          <NumberInput
            source="count"
            required
          />
        </CreateDialog>
      ),
    },
    {
      name: 'New Mission Achievement',
      type: 'component',
      if: user => user.scope === 'child',
      icon: GradeIcon,
      Component: props => (
        <CreateDialog
          {...props}
          fixedValue={{
            user_id: props.parentResource.id,
          }}
          resource="mission_achievements"
        >
          <ReferenceInput
            source="mission_id"
            required
          />
          <NestedReferenceInput
            source="project_id"
            required
          />
          <BooleanInput
            source="completed"
            defaultValue
          />
          <BooleanInput
            source="submitted"
            defaultValue
          />
        </CreateDialog>
      ),
    },
    {
      name: 'Set Temporary Password',
      type: 'component',
      if: user => user.scope === 'child',
      icon: PasswordIcon,
      Component: TemporaryPasswordDialog,
    },
  ],
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <InputGroup
          header="Contact Information"
          subHeader="Name and email information"
        >
          <EnumInput
            source="scope"
          />
          <TextInput
            source="name"
            required
          />
          <TextInput
            source="email"
          />
          {props.record.scope == 'child' && (
            <TextInput
              source="password"
            />
          )}
          <DateInput
            source="date_of_birth"
          />
          <EnumInput
            source="difficulty_level"
          />
        </InputGroup>

        <InputGroup
          header="Influencer Program"
          subHeader="Members of our Influencer program assist us in promoting our brand and product accross social media and other platforms"
        >
          <BooleanInput
            source="verified"
          />
        </InputGroup>

        <InputGroup
          header="Ambassador Program"
          subHeader="Members of our ambassador program are typically partners, rather than parents. They use different referral codes than regular customers, and are paid in cash for sending us new customers"
        >
          <BooleanInput
            source="ambassador"
          />
        </InputGroup>

        <InputGroup
          header="User Preferences"
        >
          <TimeZoneSelectInput
            choices={[
              {id: 'America/New_York', name: 'Eastern'},
              {id: 'America/Chicago', name: 'Central'},
              {id: 'America/Denver', name: 'Mountain'},
              {id: 'America/Los_Angeles', name: 'Pacific'},

              {id: null, name: 'Other Time Zones', disabled: true},
              {id: 'Africa/Lagos', name: 'Africa/Lagos'},
              {id: 'Africa/Johannesburg', name: 'Africa/Johannesburg'},
              {id: 'America/Bogota', name: 'America/Bogota'},
              {id: 'America/Juneau', name: 'America/Juneau'},
              {id: 'America/Phoenix', name: 'America/Phoenix'},
              {id: 'America/Guyana', name: 'America/Guyana'},
              {id: 'America/Halifax', name: 'America/Halifax'},
              {id: 'Asia/Baghdad', name: 'Asia/Baghdad'},
              {id: 'Asia/Colombo', name: 'Asia/Colombo'},
              {id: 'Asia/Tbilisi', name: 'Asia/Tbilisi'},
              {id: 'Asia/Hong_Kong', name: 'Asia/Hong_Kong'},
              {id: 'Asia/Jerusalem', name: 'Asia/Jerusalem'},
              {id: 'Asia/Kolkata', name: 'Asia/Kolkata'},
              {id: 'Asia/Kuwait', name: 'Asia/Kuwait'},
              {id: 'Asia/Seoul', name: 'Asia/Seoul'},
              {id: 'Asia/Shanghai', name: 'Asia/Shanghai'},
              {id: 'Asia/Singapore', name: 'Asia/Singapore'},
              {id: 'Asia/Taipei', name: 'Asia/Taipei'},
              {id: 'Asia/Tokyo', name: 'Asia/Tokyo'},
              {id: 'Australia/Perth', name: 'Australia/Perth'},
              {id: 'Australia/Sydney', name: 'Australia/Sydney'},
              {id: 'Europe/Copenhagen', name: 'Europe/Copenhagen'},
              {id: 'Europe/Dublin', name: 'Europe/Dublin'},
              {id: 'Europe/Helsinki', name: 'Europe/Helsinki'},
              {id: 'Europe/Istanbul', name: 'Europe/Istanbul'},
              {id: 'Europe/London', name: 'Europe/London'},
              {id: 'Europe/Madrid', name: 'Europe/Madrid'},
              {id: 'Europe/Oslo', name: 'Europe/Oslo'},
              {id: 'Europe/Paris', name: 'Europe/Paris'},
              {id: 'Europe/Stockholm', name: 'Europe/Stockholm'},
              {id: 'Europe/Zurich', name: 'Europe/Zurich'},
              {id: 'Pacific/Auckland', name: 'Pacific/Auckland'},
              {id: 'Pacific/Honolulu', name: 'Pacific/Honolulu'},
            ]}
          />
          <BooleanInput
            source="do_not_email"
          />
        </InputGroup>

        <InputGroup
          header="Avatar"
          subHeader="Choose an avatar for this user."
        >
          <ReferenceInput
            reference="avatars"
            source="avatar_id"
          />
        </InputGroup>

        <InputGroup
          header="Administration"
          subHeader="If this user is a duplicate of another already in the system, select the original user here. This will automatically delete the current user."
        >
          <ReferenceInput
            filer={{ has_email: "true" }}
            optionText={users => `${users.name} (${users.email}) - Created ${moment(users.created_at).format('lll')}`}
            reference="users"
            source="duplicate_of_id"
          />
        </InputGroup>
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ organization_id: props.parentResource.id }}
        {...props}
      >
        <InputGroup
          header="Contact Information"
          subHeader="Name and email information"
        >
          <EnumInput
            source="scope"
          />
          <TextInput
            source="name"
            required
          />
          <TextInput
            source="email"
          />
          <TextInput
            source="password"
          />
          <DateInput
            source="date_of_birth"
          />
          <EnumInput
            defaultValue="beginner"
            source="difficulty_level"
          />
        </InputGroup>

        <InputGroup
          header="Ambassador Program"
          subHeader="Members of our ambassador program are typically partners, rather than parents. They use different referral codes than regular customers, and are paid in cash for sending us new customers"
        >
          <BooleanInput
            source="ambassador"
          />
        </InputGroup>

        <InputGroup
          header="User Preferences"
        >
          <TimeZoneSelectInput
            choices={[
              {id: 'America/New_York', name: 'Eastern'},
              {id: 'America/Chicago', name: 'Central'},
              {id: 'America/Denver', name: 'Mountain'},
              {id: 'America/Los_Angeles', name: 'Pacific'},

              {id: null, name: 'Other Time Zones', disabled: true},
              {id: 'Africa/Lagos', name: 'Africa/Lagos'},
              {id: 'Africa/Johannesburg', name: 'Africa/Johannesburg'},
              {id: 'America/Bogota', name: 'America/Bogota'},
              {id: 'America/Juneau', name: 'America/Juneau'},
              {id: 'America/Phoenix', name: 'America/Phoenix'},
              {id: 'America/Guyana', name: 'America/Guyana'},
              {id: 'America/Halifax', name: 'America/Halifax'},
              {id: 'Asia/Baghdad', name: 'Asia/Baghdad'},
              {id: 'Asia/Colombo', name: 'Asia/Colombo'},
              {id: 'Asia/Tbilisi', name: 'Asia/Tbilisi'},
              {id: 'Asia/Hong_Kong', name: 'Asia/Hong_Kong'},
              {id: 'Asia/Jerusalem', name: 'Asia/Jerusalem'},
              {id: 'Asia/Kolkata', name: 'Asia/Kolkata'},
              {id: 'Asia/Kuwait', name: 'Asia/Kuwait'},
              {id: 'Asia/Seoul', name: 'Asia/Seoul'},
              {id: 'Asia/Shanghai', name: 'Asia/Shanghai'},
              {id: 'Asia/Singapore', name: 'Asia/Singapore'},
              {id: 'Asia/Taipei', name: 'Asia/Taipei'},
              {id: 'Asia/Tokyo', name: 'Asia/Tokyo'},
              {id: 'Australia/Perth', name: 'Australia/Perth'},
              {id: 'Australia/Sydney', name: 'Australia/Sydney'},
              {id: 'Europe/Copenhagen', name: 'Europe/Copenhagen'},
              {id: 'Europe/Dublin', name: 'Europe/Dublin'},
              {id: 'Europe/Helsinki', name: 'Europe/Helsinki'},
              {id: 'Europe/Istanbul', name: 'Europe/Istanbul'},
              {id: 'Europe/London', name: 'Europe/London'},
              {id: 'Europe/Madrid', name: 'Europe/Madrid'},
              {id: 'Europe/Oslo', name: 'Europe/Oslo'},
              {id: 'Europe/Paris', name: 'Europe/Paris'},
              {id: 'Europe/Stockholm', name: 'Europe/Stockholm'},
              {id: 'Europe/Zurich', name: 'Europe/Zurich'},
              {id: 'Pacific/Auckland', name: 'Pacific/Auckland'},
              {id: 'Pacific/Honolulu', name: 'Pacific/Honolulu'},
            ]}
          />
        </InputGroup>

        <InputGroup
          header="Avatar"
          subHeader="Choose an avatar for this user."
        >
          <ReferenceInput
            reference="avatars"
            source="avatar_id"
          />
        </InputGroup>
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <EnumField
          sortable={false}
          source="scope"
        />
        <TextField
          sortable={false}
          source="name"
        />
        <TextField
          source="email"
        />
        <AgeField
          sortable={false}
          showDateOfBirth
        />
        <TextField
          sortable={false}
          source="referral_code"
        />
        <BooleanField
          sortable={false}
          source="verified"
          addLabel
        />
        <BooleanField
          sortable={false}
          source="ambassador"
          addLabel
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TabbedShowLayout>
          <Tab
            label="summary"
          >
            <DateField
              source="created_at"
            />
            <TextField
              source="id"
            />
            <EnumField
              source="scope"
            />
            <TextField
              source="name"
            />
            <TextField
              source="email"
            />
            <AgeField />
            <DateField
              source="date_of_birth"
            />
            <TextField
              source="referral_code"
            />
            <BooleanField
              source="verified"
              addLabel
            />
            <BooleanField
              label="On Temporary Password"
              source="temporary_password"
              addLabel
            />
            <BooleanField
              source="ambassador"
              addLabel
            />
            <TimeZoneField
              source="time_zone"
              addLabel
            />
            <BooleanField
              source="do_not_email"
              addLabel
            />
            <ReferenceField
              reference="avatars"
              source="avatar_id"
              allowEmpty
            >
              <ImageField
                source="file"
              />
            </ReferenceField>

            <NestedResourceList
              reference="memberships"
            >
              <LinkField
                source="organization_id"
              />
              <TextField
                source="badge"
              />
              <EnumField
                source="role"
              />
              <BooleanField
                source="accepted"
              />
            </NestedResourceList>
          </Tab>

          <Tab
            label="Curriculum"
          >
            <LinkField
              source="rank_id"
            />

            <LinkField
              source="guide_rank_id"
            />

            <NestedResourceList
              perPage={10}
              reference="badge_achievements"
            >
              <LinkField
                source="badge_id"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              perPage={10}
              reference="mission_achievements"
            >
              <LinkField
                source="mission_id"
              />
              <LinkField
                parentReference="users"
                parentSource="user_id"
                source="project_id"
              />
              <BooleanField
                source="completed"
              />
              <BooleanField
                source="submitted"
              />
              <BooleanField
                source="failed"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              perPage={10}
              reference="curriculum_accomplishments"
            >
              <LinkField
                source="project_id"
              />
              <LinkField
                displaySource="difficulty_level"
                label="Difficulty Level"
                source="curriculum_activity_id"
              />
              <LinkField
                source="curriculum_activity_id"
              />
              <NumberField
                source="count"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              reference="curriculum_scores"
            >
              <LinkField
                source="skill_id"
              />
              <NumberField
                source="points"
              />
              <SkillProgressField />
            </NestedResourceList>
          </Tab>

          <Tab
            label="Projects"
          >
            <NestedResourceList
              perPage={10}
              reference="projects"
            >
              <TextField
                source="name"
              />
              <DateTimeField
                source="created_at"
              />
              <ImageField
                source="screenshot_2x"
              />
              <TextField
                source="current_kidscript_version"
              />
              <CurrentVersionField />
              <EnumField
                source="visibility"
              />
              <BooleanField
                source="archived"
              />
              <EditableProjectLinkField />
            </NestedResourceList>
          </Tab>

          <Tab
            label="Social"
          >
            <BooleanField
              source="private_profile"
              addLabel
            />
            <TextField
              source="follower_count"
            />
            <TextField
              source="following_count"
            />

            <NestedResourceList
              reference="followings"
            >
              <LinkField
                reference="users"
                source="following_id"
              />
            </NestedResourceList>
          </Tab>
        </TabbedShowLayout>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="name"
        />
        <EnumInput
          source="scope"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
    Expand: props => (
      <SimpleShowLayout
        {...props}
      >
        <DateField
          source="created_at"
        />
        <TimeZoneField
          source="time_zone"
          addLabel
        />
        <ReferenceManyField
          label="Badge"
          reference="memberships"
          target="user_id"
        >
          <SingleFieldList>
            <TextField
              source="badge"
            />
          </SingleFieldList>
        </ReferenceManyField>

        <NestedResourceList
          perPage={5}
          reference="projects"
        >
          <TextField
            source="name"
          />
          <ImageField
            source="screenshot"
          />
          <DateTimeField
            source="created_at"
          />
        </NestedResourceList>
      </SimpleShowLayout>
    ),
  },
  resources: {
    projects,
    memberships,
    curriculum_accomplishments,
    mission_achievements,
    friend_requests,
    followings,
  },
};
